// A shortened Reader View teaser keeps the author's saved paragraph boundaries.
// Rich formatting remains the responsibility of the full-scene read-only renderer.
export function openingSceneExcerpt(value, maxWords = 150) {
  const text = String(value || "").trim();
  if (!text) return "";

  const limit =
    Number.isFinite(maxWords) && maxWords >= 1
      ? Math.max(1, Math.floor(maxWords))
      : 150;
  const wordMatcher = /\S+/g;
  let match = null;

  for (let index = 0; index < limit; index += 1) {
    match = wordMatcher.exec(text);
    if (!match) return text;
  }

  if (!wordMatcher.exec(text)) return text;
  return text.slice(0, match.index + match[0].length) + "…";
}
